export default function RenderLocationTree({ data }) {
  return (
    <ul>
      {data.map((node) => (
        <li key={node.name}>
          {node.name}
          {node.children && node.children.length > 0 && <RenderLocationTree data={node.children} />}
        </li>
      ))}
    </ul>
  )
}

export const isAssessmentLocation = (datas) => {
  var result = []

  var obj = datas?.find((e) => e.type == '7' || e.type == '8')

  if (obj) {
    return true
  } else {
    for (let item of datas) {
      if (item.options?.length > 0) {
        for (let option of item.options) {
          if (option.extends?.length > 0) {
            var extendsResult = isAssessmentLocation(option.extends)
            if (extendsResult) {
              return extendsResult
            }
          }
        }
      }

      if (item.children?.length > 0) {
        var childResult = isAssessmentLocation(item.children)
        if (childResult) {
          return childResult
        }
      }

      return false
    }
  }

  return result
}
